import './menu-accessability.js';

(function () {
    //document.activeElement

    var $body = $('body'),
        $window = $(window),
        tabKey = 9,
        escKey = 27,
        enterKey = 13;

    var menu = {
        $toggle: $('[data-toggle="nav"]'),
        $target: null,
        revers: false,
        lastItem: null,
        items: null,
        vPort: ['screen-sm'],
        isMobile: false, // variable use to determine if responsive mode is on or off
        menuHeaderMainTitle: '',
        redirectPath: false,
        displayedNestedItems: false,
        nestedMenu: undefined,
        listPositionVars: {
            mainScrollingList: $('#menubar'),
            inTimeoutTiming: null, // override these if you want a custom listPosition.handle in or out timeout time
            outTimeoutTiming: null,
            mainScrollingListHeight: false,
            mobileTransitionTime: 400, // should usually keep it the same as the transition time for `.main-nav.menu--res li`'s that's in drawer.scss,
            bodyTransitionPropertyName: 'transform', // this one,
            bodyTransitionElapsedTime: 0.25, // and this one depend on the type and duration of the sidebar `show` transition (currently under `.lock-screen[data-active='menu']` in drawer.scss)
        },
        targetOffset: 70,

        init: function () {
            $('.main-nav').each(function (index) {
                menu.$target = $(this);
                const $header = menu.$target.find('.menu-header');
                menu.menuHeaderMainTitle = $header.text();
                menu.redirectPath = $header.data('redirect-to');
                menu.check.viewPort(index);
                menu.responsive(index);
            });
            $('.main-nav__toggle__controller').attr('aria-expanded', 'false');
            menu.items = $('.main-nav').find('a, button, input'); //$(".header__nav a, .header__nav button, .header__nav input");
            menu.control();
            menu.additionalControl();
        },

        responsive: function (index) {
            $(document).on(menu.vPort[index] + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                menu.isMobile = true;
                $('.main-nav').each(function () {
                    if ($(this).find('.drawer__nav').data('ctrl-res') === menu.vPort[index]) {
                        $(this).addClass('menu--res'); // class will be used in our scss (to replace media queries)
                        $('.main-nav__toggle__controller').addClass('main-nav__toggle__controller__res'); // class will be used in our scss (to replace media queries)
                        menu.on.rebuild.responsive(); // rebuild menu to be responsive - drawer
                    }
                });
            });

            $(document).on(menu.vPort[index] + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                menu.isMobile = false;
                $('.main-nav').each(function () {
                    if ($(this).find('.drawer__nav').data('ctrl-res') === menu.vPort[index]) {
                        $(this).removeClass('menu--res'); // class will be used in our scss (to replace media queries)
                        $('.main-nav__toggle__controller').removeClass('main-nav__toggle__controller__res'); // class will be used in our scss (to replace media queries)
                        menu.on.rebuild.original(); // return menu as default
                    }
                });
            });
        },

        control: function () {
            $body.on('click', '[data-toggle="nav"]', function (e) {
                e.preventDefault();
                menu.$toggle = $(this);
                menu.$target = $('#' + menu.$toggle.data('target'));

                menu.items = menu.$target.find('a, button, input'); //$(".header__nav a, .header__nav button, .header__nav input");
                menu.items.each(function (index) {
                    if (index === menu.items.length - 1) {
                        menu.lastItem = $(this);
                    }
                });

                menu.on.show(e);
            });

            $body.on('click', '.js--open[data-toggle="nav"]', function (e) {
                e.preventDefault();
                menu.on.hide(e);
            });

            $body.on('click', function (e) {
                if (!$(e.target).closest('.dropdown__toggle').length) {
                    $('a.dropdown__toggle.hover').removeClass('hover');
                }
                if (
                    !$(e.target).hasClass('icon-arrow_r') &&
                    !$(e.target).parents('.main-nav__toggle__controller') &&
                    !$(e.target).parents('.main-nav.menu--res').length &&
                    $('.lock-screen[data-active="menu"]').length
                ) {
                    menu.on.hide(e);
                }
            });

            $body.on('click', '.main-nav a', function (e) {
                const href = $(this).attr('href');

                if (href === '#') {
                    e.preventDefault();
                } else if (href && href.indexOf('#') !== -1) {
                    // Check if the href contains a hash (e.g., /page/worldscibooks#new-titles)
                    e.preventDefault();

                    const targetId = href.split('#')[1]; // Get the part after the hash (e.g., new-titles)
                    const target = $('#' + targetId);
                    menu.on.hide();

                    if (target.length) {
                        $('html, body').animate(
                            {
                                scrollTop: target.offset().top - menu.targetOffset,
                            },
                            50,
                            function () {
                                menu.on.hide();
                            }
                        );
                    } else {
                        window.location.href = href;
                    }
                }
            });

            $body.on('click touchend', '[data-toggle="dropdown"]', function (e) {
                e.preventDefault();
                menu.nestedMenu = $(this);
                menu.on.nested(e);
            });
            $body.on('click', '.menu-header', function (e) {
                e.preventDefault();

                if (menu.isMobile) {
                    menu.on.hideNested(true);
                }
                e.stopPropagation(); // prevent closing menu when getting back from nested menu
            });
            $body.on('keydown', '.drawer__nav, [data-toggle="nav"]', function (e) {
                if (menu.isMobile) {
                    if ((e.keyCode || e.which) === tabKey) {
                        if (!menu.revers) {
                            menu.on.tab();
                        } else {
                            menu.on.tabRevers();
                        }
                    }
                }
            });

            // without .get(0) e.elapsedTime and e.propertyName are undefined
            $body.get(0).addEventListener('transitionend', menu.on.listPosition.handleHeightSet);
            $window.on('resize', menu.on.listPosition.handleResize);

            $window.on('keyup', function (e) {
                menu.revers = !!(e.shiftKey && e.keyCode === tabKey);
                if (!menu.isMobile) {
                    if ((e.keyCode || e.which) === tabKey || enterKey) {
                        menu.on.tabDesktop(e, menu.revers, e.keyCode);
                    }

                    if ((e.keyCode || e.which) === escKey) {
                        menu.on.escDesktop(e);
                    }
                }
            });
        },
        additionalControl: function () {},
        on: {
            show: function () {
                if (typeof UX.controller != 'undefined') {
                    UX.controller.check();
                }
                $body.addClass('lock-screen').attr('data-active', 'menu');
                menu.$toggle.addClass('js--open');

                menu.$target.closest('.main-nav').css('top', $window.scrollTop());
                $('.coolBar--res')
                    .removeClass('trans')
                    .css('top', $window.scrollTop() + $('header').height());
                $('.loi__banner.loi--res').css('top', $window.scrollTop() + $('header').height());
                $('.main-nav__toggle__controller').attr('aria-expanded', 'true');
                menu.$target.attr('style', 'display: block !important');
                menu.$toggle.focus();
                menu.on.showAdditional();
            },
            showAdditional: function () {},
            showNested: function () {
                menu.on.listPosition.start('in');
                menu.nestedMenu.next('.dropdown__menu').toggleClass('sub-menu__opened');
                menu.nestedMenu.parent().toggleClass('menu-parent__opened');
                menu.nestedMenu.find('i').toggleClass('opposite-arrow');
                menu.nestedMenu.parent().siblings('li').toggleClass('prev-items');
                menu.nestedMenu.toggleClass('prev-items');
                $("[data-toggle='nav']").addClass('js--nested-open'); // replace Close button with back button after nested menu get opened
                const $menuTitle = menu.nestedMenu.html();

                if ($('.menu-header').length) {
                    $('.menu-header').html($menuTitle);
                }
                menu.displayedNestedItems = true;

                menu.on.showNestedExtra();
            },
            showNestedExtra: function () {},
            hideNested: function (shouldNavigate = false) {
                var $menuHeader = $('.menu-header');
                var $parenNestedMenu;

                if (typeof menu.nestedMenu != 'undefined') {
                    menu.on.listPosition.start('out');
                    $parenNestedMenu = menu.nestedMenu.parent().parent(); // first parent list
                    menu.nestedMenu = $parenNestedMenu.parent().find('.dropdown__toggle'); // first parent dropdown toggle link

                    $parenNestedMenu.find('.sub-menu__opened').removeClass('sub-menu__opened');
                    $parenNestedMenu.find('.menu-parent__opened').removeClass('menu-parent__opened');
                    $parenNestedMenu.find('.prev-items').removeClass('prev-items');
                    $("[data-toggle='nav']").removeClass('js--nested-open');

                    if ($parenNestedMenu.hasClass('sub-menu__opened')) {
                        $menuHeader.find('span').html(menu.nestedMenu.find('span').html());
                    } else {
                        if (menu.redirectPath && shouldNavigate && !menu.displayedNestedItems) {
                            document.location = menu.redirectPath;
                        } else {
                            $menuHeader.html(menu.menuHeaderMainTitle);
                            menu.displayedNestedItems = false;
                        }
                    }
                } else {
                    menu.nestedMenu = $menuHeader;
                }

                menu.on.hideNestedExtra();
            },
            hideNestedExtra: function () {},
            hide: function () {
                if (menu.isMobile) {
                    // hide nested menu before closing
                    menu.on.hideNested();
                }
                menu.$toggle.removeClass('js--open');
                $('.main-nav, header').css('top', 0);
                $('.coolBar--res').addClass('trans').css('top', $('header').height()); // The magic number contains 1px of border and
                $('.loi__banner.loi--res').css('top', $('header').height());
                $body.removeAttr('data-active').removeClass('lock-screen');
                $('.main-nav__toggle__controller').attr('aria-expanded', 'false');
                menu.on.listPosition.reset();
            },
            escape: function () {
                menu.on.hide();
                menu.$toggle.focus();
            },
            tab: function () {
                menu.$toggle.off();
                menu.lastItem.off().on('focusout', function () {
                    menu.$toggle.focus();
                });
            },
            tabRevers: function () {
                menu.lastItem.off();
                menu.$toggle.off().on('focusout', function () {
                    menu.lastItem.focus();
                });
            },
            tabDesktop: function (e, revers, keyCode) {
                var $target = $(e.target);
                var $parentMenu = $target.closest('.dropdown__menu');
                var $dropdownToggle = $('.dropdown__toggle');
                var dropdownMenu = '.dropdown__menu';

                if (!$target.closest('ul').length) {
                    $dropdownToggle.removeClass('hover');
                    $('.dropdown').removeClass('js--open');
                }

                if ($target.hasClass('dropdown__toggle')) {
                    if (
                        $parentMenu.length === 0 ||
                        (!$parentMenu.hasClass('js--open') && $parentMenu.find('.js--open').length === 0)
                    ) {
                        $dropdownToggle.removeClass('hover');
                        $(dropdownMenu).removeClass('js--open');
                        $target.closest('a').addClass('hover');
                        $target.siblings(dropdownMenu).addClass('js--open');
                    } else {
                        $parentMenu.find('.hover').removeClass('hover');
                        $parentMenu.find('.js--open').removeClass('js--open');
                        $target.closest('a').addClass('hover');
                        $target.siblings(dropdownMenu).addClass('js--open');
                    }
                    if (keyCode == enterKey) {
                        $(e.target).closest('a').addClass('hover');
                    }
                } else {
                    $target.closest('ul').find('.hover').removeClass('hover');
                }
            },
            escDesktop: function (e) {
                $(e.target).closest('.dropdown__toggle').removeClass('hover');
            },
            rebuild: {
                responsive: function () {
                    menu.on.hide();
                },
                original: function () {
                    menu.on.hide();
                    menu.$target.show();
                },
            },
            nested: function (e) {
                //e.preventDefault();
                if (menu.isMobile) {
                    menu.on.showNested();
                }
            },
            listPosition: {
                start: function (direction) {
                    if (!menu.nestedMenu || !direction || !menu.isMobile) return;
                    let $firstNestedMenu = menu.nestedMenu.first();
                    if (!$firstNestedMenu.closest('#menubar').length) return; // this function should only work inside #menubar

                    switch (direction) {
                        case 'in': {
                            let $prevMenu = $firstNestedMenu.closest('.dropdown__menu, #menubar'),
                                $nextMenu = $firstNestedMenu.next('.dropdown__menu');
                            menu.on.listPosition.handle(
                                {prev: $prevMenu, next: $nextMenu, parent: $prevMenu, sub: $nextMenu},
                                'in'
                            );

                            break;
                        }
                        case 'out': {
                            let addDataOnly = $firstNestedMenu.hasClass('menu-header'),
                                $prevMenu = $firstNestedMenu.next('.dropdown__menu'),
                                $nextMenu = $firstNestedMenu.closest('.dropdown__menu, #menubar');
                            menu.on.listPosition.handle(
                                {prev: $prevMenu, next: $nextMenu, parent: $nextMenu, sub: $prevMenu},
                                'out',
                                addDataOnly
                            );

                            break;
                        }
                    }
                },
                handle: function (menuElements, direction = {}, addDataOnly) {
                    let timing = direction === 'in' ? 0 : menu.listPositionVars.mobileTransitionTime / 3, // 0 timing is good for in direction, looks bad for out
                        timeoutTime =
                            direction === 'in' && menu.listPositionVars.inTimeoutTiming
                                ? menu.listPositionVars.inTimeoutTiming
                                : direction === 'out' && menu.listPositionVars.outTimeoutTiming
                                ? menu.listPositionVars.outTimeoutTiming
                                : menu.listPositionVars.mobileTransitionTime / 3;

                    menu.on.listPosition.addDataToElem(menuElements.prev);
                    if (addDataOnly === true) return;

                    menu.on.listPosition.handleScrollBarHide([menuElements.prev, menuElements.next]);

                    if (menuElements.next.length) {
                        let lastScrollVal = menu.on.listPosition.getLastPosition(menuElements.next);

                        setTimeout(() => {
                            menu.on.listPosition.scrollTo(
                                menuElements,
                                direction,
                                lastScrollVal ? lastScrollVal : 0,
                                timing
                            );
                        }, timeoutTime); // a timeout so the transition happens just before the next list enters the viewport
                    }
                },
                addDataToElem: function ($elem) {
                    if ($elem.length) {
                        let rect = $elem.get(0).getBoundingClientRect();

                        $elem.attr(
                            'data-last-pos',
                            JSON.stringify({
                                bottom: Math.floor(rect.bottom),
                                scrollVal: Math.floor($elem.first().scrollTop()),
                            })
                        );
                    }
                },
                getLastPosition: function ($elem) {
                    return $elem.attr('data-last-pos') && JSON.parse($elem.attr('data-last-pos')).scrollVal;
                },
                handleScrollBarHide: function (elemsArr) {
                    elemsArr.forEach($elem => {
                        $elem.addClass('scrollbar-hidden');

                        if (!$elem.attr('data-transitionend-listener-added')) {
                            $elem.attr('data-transitionend-listener-added', 'true');
                            $elem.on('transitionend', e => {
                                $elem.removeClass('scrollbar-hidden');
                            });
                        }
                    });
                },
                scrollTo: function (menuElements, direction, value, timing = 0) {
                    let parentHeightVal =
                            menu.listPositionVars.mainScrollingListHeight -
                            (menuElements.parent.innerHeight() - menuElements.parent.height()), // height minus padding
                        subHeightVal =
                            menu.listPositionVars.mainScrollingListHeight -
                            (menuElements.sub.innerHeight() - menuElements.sub.height()); // height minus padding

                    if (UX.utils.isSafari()) {
                        subHeightVal = subHeightVal - 180;
                    }

                    if (direction === 'in') {
                        menuElements.parent
                            .css({'max-height': parentHeightVal, height: parentHeightVal, 'overflow-y': 'hidden'})
                            .attr('data-list-pos-corrected', 'true');
                        menuElements.sub
                            .css({'max-height': subHeightVal, height: subHeightVal, 'overflow-y': 'auto'})
                            .attr('data-list-pos-corrected', 'true');

                        menuElements.parent.length &&
                            menuElements.parent.animate(
                                {
                                    scrollTop: 0, // if we don't scroll the parent to the top, the sub will sometimes be cut off
                                },
                                {
                                    duration: Math.abs(value - menuElements.parent.scrollTop()) > 125 ? 0 : timing,
                                }
                            );

                        menuElements.sub.animate(
                            {
                                scrollTop: value,
                            },
                            {
                                duration: Math.abs(value - menuElements.parent.scrollTop()) > 125 ? 0 : timing,
                            }
                        );
                    } else if (direction === 'out') {
                        menuElements.parent.css({
                            'max-height': parentHeightVal,
                            height: parentHeightVal,
                            'overflow-y': 'auto',
                        });
                        menuElements.sub
                            .css({'max-height': '', height: '', 'overflow-y': ''})
                            .removeAttr('data-list-pos-corrected');

                        menuElements.parent.length &&
                            menuElements.parent.animate(
                                {
                                    scrollTop: value,
                                },
                                {
                                    duration: Math.abs(value - menuElements.parent.scrollTop()) > 125 ? 0 : timing,
                                }
                            );
                    }
                },
                handleResize: function (e) {
                    if (menu.$toggle.hasClass('js--open')) {
                        menu.on.listPosition.handleHeightSet({}, {skipCheck: true});
                    }
                },
                handleHeightSet: function (e = {}, options = {}) {
                    if (
                        (menu.$toggle.hasClass('js--open') &&
                            e.elapsedTime === menu.listPositionVars.bodyTransitionElapsedTime &&
                            e.propertyName === menu.listPositionVars.bodyTransitionPropertyName) ||
                        options.skipCheck === true
                    ) {
                        // not using $window.outerHeight() because it's return value doesn't change with the resize event
                        menu.listPositionVars.mainScrollingListHeight =
                            window.outerHeight - menu.listPositionVars.mainScrollingList[0].getBoundingClientRect().top;
                        menu.listPositionVars.mainScrollingList
                            .find('[data-list-pos-corrected="true"]')
                            .add(menu.listPositionVars.mainScrollingList)
                            .css({
                                height: menu.listPositionVars.mainScrollingListHeight,
                                'max-height': menu.listPositionVars.mainScrollingListHeight,
                            });
                    }
                },
                reset: function () {
                    menu.listPositionVars.mainScrollingList
                        .find('[data-last-pos], [data-list-pos-corrected]')
                        .add(menu.listPositionVars.mainScrollingList)
                        .removeAttr('data-last-pos data-list-pos-corrected')
                        .css({'max-height': '', height: '', 'overflow-y': ''})
                        .animate(
                            {
                                scrollTop: 0,
                            },
                            0
                        );
                },
            },
        },
        check: {
            viewPort: function (index) {
                if (menu.$target.find('.drawer__nav').attr('data-ctrl-res')) {
                    menu.vPort[index] = menu.$target.find('.drawer__nav').attr('data-ctrl-res');
                }
            },
        },
    };

    UX.menu = menu; // add to global namespace
})();
